import type { AppRoute } from '@/lib/routing/routing.types'
import { lazyWithRetry } from '@/lib/utils/lazy-with-retry'

const KeywordResearchPage = lazyWithRetry(() =>
  import('./pages/KeywordResearchPage').then((module) => ({
    default: module.KeywordResearchPage,
  })),
)

const KeywordResearchListPage = lazyWithRetry(() =>
  import('./pages/KeywordResearchListPage').then((module) => ({
    default: module.KeywordResearchListPage,
  })),
)

const KeywordResearchDetailPage = lazyWithRetry(() =>
  import('./pages/KeywordResearchDetailPage').then((module) => ({
    default: module.KeywordResearchDetailPage,
  })),
)

const routes: AppRoute[] = [
  {
    path: 'keywords',
    children: [
      {
        index: true,
        element: KeywordResearchListPage,
        meta: { title: 'keywordResearch.list.title' },
      },
      {
        path: ':id',
        element: KeywordResearchDetailPage,
        meta: { title: 'keywordResearch.detail.backToList' },
      },
    ],
  },
  {
    path: 'keyword-research',
    children: [
      {
        index: true,
        element: KeywordResearchPage,
        meta: { title: 'keywordResearch.title' },
      },
    ],
  },
]

export default routes
